import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("trx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export const formatMiles = (n) => `${Number(n).toLocaleString("en-US")} mi`;

export const apiError = (e, fallback = "Something went wrong. Please try again.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return fallback;
};
